import { isSameDay, isSameHour, parseISO } from "date-fns";
import React, { useState, useEffect } from "react";
import useCalendar from "../customHooks/useCalendar";
import { dateTimeFormatter } from "../helperFunctions/dateFormatters";
import "../css/jobStatusFormContainer.scss";

import { status_of_jobsheets, colourScheme } from "../popData";
import CopyContainer from "./CopyContainer";
import { doc } from "firebase/firestore";
import { updatePrimary } from "../helperFunctions/primaryWrites";

const JobStatusForm = (props) => {
  let { formData, inputHandler, saveInput, params, dbRef } = props;
  const [sameDayJobs, setSameDayJobs] = useState([]);
  const [currentBookedInDate, setCurrentBookedInDate] = useState(null);
  const [daysData] = useCalendar(currentBookedInDate);

  useEffect(() => {
    // filter the output here and only get the current day
    let dayData = daysData.find((day) => {
      if (isSameDay(day.date, currentBookedInDate)) {
        return true;
      }
      return false;
    });

    setSameDayJobs(dayData?.data ?? []);
  }, [daysData, currentBookedInDate]);

  //   useEffect(() => {
  //     Will show the same day jobs container on page load
  //     if (!currentBookedInDate && formData?.bookedInDateTime) {
  //       setCurrentBookedInDate(parseISO(formData.bookedInDateTime));
  //     }
  //   }, [formData?.bookedInDateTime]);

  function handleStatus(e) {
    let name = e.target.name;
    let value = e.target.value;

    updatePrimary(doc(dbRef, `${params.uid}`), { [name]: value });
  }

  function handleDateChange(e) {
    // On changing of the date, show jobs on that day.
    let newDate = new Date(e.target.value);

    if (newDate) {
      setCurrentBookedInDate(newDate);
    }

    // Update the primary form with the change
    inputHandler(e);
  }

  function showOtherDays() {
    if (!currentBookedInDate && formData?.bookedInDateTime) {
      setCurrentBookedInDate(parseISO(formData.bookedInDateTime));
    }
  }

  function handleSave(e) {
    // Remove container which shows other jobs booked on that day
    setCurrentBookedInDate(null);
    // Update the database with the change of booking date
    saveInput(e);
  }

  return (
    <div className="jobStatusFormContainer">
      <div className="statusLine">
        <div className="formLine">
          {/* <label>Status</label> */}
          <select
            name="status"
            id="status"
            data-testid="select-option"
            className="status-field"
            style={{
              ...colourScheme[formData?.status],
            }}
            onChange={handleStatus}
            value={formData?.status ?? ""}
          >
            {status_of_jobsheets.map((status) => {
              return (
                <option key={status.key} value={status.value}>
                  {status.name}
                </option>
              );
            })}
          </select>
        </div>
      </div>
      {/* ) : null} */}

      {(formData?.status === "awaiting-quote" ||
        formData?.status === "quote-sent" ||
        formData?.status === "booked-in" ||
        formData?.status === "provisional" ||
        formData?.status === "completed" ||
        formData?.status === "in-progress" ||
        formData?.status === "unresolved" ||
        formData?.status === "arrange-date") && (
        <div className="bookedInAndTemplates">
          <div className="bookedInLine">
            <label htmlFor="bookedInDateTime">Booked In</label>
            <input
              className="bookedInDateTime"
              name="bookedInDateTime"
              id="bookedInDateTime"
              type="datetime-local"
              value={formData?.bookedInDateTime ?? ""}
              onChange={handleDateChange}
              onFocus={showOtherDays}
              onBlur={handleSave}
            />
            {/* <input
              className="estimatedTime"
              type="number"
              name="bookedInTime"
              id="bookedInTime"
              placeholder="estimated time"
            /> */}
          </div>

          <CopyContainer primaryFormData={formData} dbRef={dbRef} vat={formData?.vatMode} />
        </div>
      )}

      <div className="same-day-jobs">
        {/* {sameDayJobs?.length > 0 && (
          <p className="same-day-label">
            Other jobs on {dateTimeFormatter(currentBookedInDate, "d_short")}
          </p>
        )} */}
        {sameDayJobs.map((job) => {
          if (job.uid !== params.uid) {
            let description = job?.authorisedBy || job?.name || job?.refNumber || "?";

            let isDoubleBooked = isSameHour(parseISO(job?.bookedInDateTime), currentBookedInDate);
            return (
              <p
                title={description}
                className={`job-time-line ${isDoubleBooked && "double-booked"}`}
                key={job.uid}
              >
                {dateTimeFormatter(job?.bookedInDateTime, "t_short")}
              </p>
            );
          }
        })}
      </div>
    </div>
  );
};

export default JobStatusForm;
